"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendEvent = exports.getTracker = exports.initLoggingOnLoad = exports.trackEvent = exports.debugOnClient = void 0;
/*global document, window */
const debug = require("debug");
const debugClient = debug('xbimz-travel');
if (process.title === 'browser') {
    // expose debug object to browser, so that it can be enabled/disabled from browser:
    // https://github.com/visionmedia/debug#browser-support
    window.fluxibleDebug = debug;
}
function debugOnClient(message) {
    debugClient(message);
}
exports.debugOnClient = debugOnClient;
function trackEvent(message, properties) {
    if (process.title === 'browser') {
        debugOnClient(`event: ${message}`);
        sendEvent(message, properties);
    }
}
exports.trackEvent = trackEvent;
function makeId(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}
class Tracker {
    constructor(userId, sessionId) {
        this.userId = userId;
        this.sessionId = sessionId;
    }
}
function initLoggingOnLoad() {
    require('perfume.js').default({
        analyticsTracker: (options) => {
            if (options.metricName === 'navigationTiming') {
                sendEvent('navigationTiming', Object.assign({ navTiming: options.data }, { path: window.location.pathname + window.location.search }));
            }
            if (options.metricName === 'networkInformation') {
                // console.log(options.data);
            }
            if (options.metricName === 'tbt') {
                // console.log('totalBlockingTime', options.data);
            }
        }
    });
}
exports.initLoggingOnLoad = initLoggingOnLoad;
const sessionId = makeId('10');
function getTracker() {
    let userId = window.localStorage.getItem('userId');
    if (!userId) {
        userId = makeId('10');
        window.localStorage.setItem('userId', userId);
    }
    return new Tracker(userId, sessionId);
}
exports.getTracker = getTracker;
function sendEvent(eventId, other) {
    if (process.title !== 'browser' || window.location.href.indexOf('wow') > 0) {
        return;
    }
    const umami = window.umami;
    if (umami && typeof umami.track === 'function') {
        umami.track(eventId, other);
    }
    getCached('ipData', () => require('fetch-jsonp')('https://ipinfo.io/json?token=3767321391bbb9').then((response) => response.json()), 86000000)
        .then((ipData) => {
        const data = Object.assign(Object.assign(Object.assign(Object.assign({}, getTracker()), { eventId }), other), { ipData });
        fetch('/events', {
            method: 'POST',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: JSON.stringify(data), // body data type must match "Content-Type" header
        });
    });
}
exports.sendEvent = sendEvent;
function setWithExpiry(key, value, ttl) {
    const now = new Date();
    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
        value: JSON.stringify(value),
        expiry: now.getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
}
function getWithExpiry(key) {
    const itemStr = localStorage.getItem(key);
    // if the item doesn't exist, return null
    if (!itemStr) {
        return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
        // If the item is expired, delete the item from storage
        // and return null
        localStorage.removeItem(key);
        return null;
    }
    return JSON.parse(item.value);
}
function getCached(key, promise, ttl) {
    return __awaiter(this, void 0, void 0, function* () {
        const value = getWithExpiry(key);
        if (value != null) {
            return value;
        }
        const newVal = yield promise();
        setWithExpiry(key, value, ttl);
        return newVal;
    });
}
